// Which job is on the workbench right now. Device-local, like the iOS
// `FocusedJob.key`: it lives in localStorage, never in the store, so it never
// syncs. The home menu sets it; the focus screen reads it.
export const FOCUSED_KEY = 'hd:focusedJob';

export function focusedJob(): string | null {
  try { return localStorage.getItem(FOCUSED_KEY); } catch { return null; }
}

export function setFocusedJob(id: string | null): void {
  try {
    if (id) localStorage.setItem(FOCUSED_KEY, id);
    else localStorage.removeItem(FOCUSED_KEY);
  } catch {
    // A private window that refuses storage: focus still works for this visit.
  }
}
